import { gql } from '@apollo/client';
import { ScannerBrandInfo } from '../fragments';

export default gql`
  query scannerBrand($id: ID) {
    scannerBrand(id: $id) {
      ...ScannerBrandInfo
    }
  }
  ${ScannerBrandInfo}
`;
